import Vue from "vue";
import Vuex from "vuex";
import i18n, {loadLocaleMessagesAsync} from "@/i18n";

// PROD
import {urbanSectors} from './util/dataJson/urbanSectors.json';
import {urbanEnvironments} from './util/dataJson/urbanEnvironments.json';
import {geography} from './util/dataJson/geography.json';
import {typeOfSolutions} from './util/dataJson/typeOfSolutions.json';
import {projects} from './util/dataJson/projects.json';
import {version} from './util/getVersionFromConfig/version.json';

// TEST
// import {urbanSectors} from './util/dataJson/staging/urbanSectors.json';
// import {urbanEnvironments} from './util/dataJson/staging/urbanEnvironments.json';
// import {geography} from './util/dataJson/staging/geography.json';
// import {typeOfSolutions} from './util/dataJson/staging/typeOfSolutions.json';
// import {projects} from './util/dataJson/staging/projects.json';

Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        dataJson: {
            urbanSectors,
            urbanEnvironments,
            geography,
            typeOfSolutions,
            projects,
        },
        activeNavigation:{
            activeLocale: i18n.locale,
            activeUrbanSectors: {},
            activeUrbanEnvironmentOrGeography: "geography",
        },
        feVersion: version
    },
    mutations: {
        setActiveLocale(state, activeLocale) {
            state.activeNavigation.activeLocale = activeLocale;
        },
        setActiveUrbanSectors(state, urbanSector) {
            state.activeNavigation.activeUrbanSectors = urbanSector;
        },
        setActiveUrbanEnvironmentOrGeography(state, activeUrbanEnvironmentOrGeography) {
            state.activeNavigation.activeUrbanEnvironmentOrGeography = activeUrbanEnvironmentOrGeography;
        },
    },
    getters: {
        // varius
        getFeVersion: state => state.feVersion,
        getActiveLocale: state => state.activeNavigation.activeLocale,
        // dataJson
        getUrbanSectors: state => state.dataJson.urbanSectors,
        getUrbanEnvironments: state => state.dataJson.urbanEnvironments,
        getGeography: state => state.dataJson.geography,
        getTypeOfSolutions: state => state.dataJson.typeOfSolutions,
        getProjects: state => {
            return state.dataJson.projects.sort((a, b) =>
                (a.id.toUpperCase() < b.id.toUpperCase()) ?  -1 : 1)
        },

        getActiveUrbanSectors: state => state.activeNavigation.activeUrbanSectors,
        getActiveUrbanEnvironmentOrGeography: state => state.activeNavigation.activeUrbanEnvironmentOrGeography,

        //
        getUrbanEnvironmentKeyFromUrlParams: state => activeUrbanEnvironment => {
            return state.dataJson.urbanEnvironments
                .find(urbanEnvironment => urbanEnvironment.key.toLowerCase() === activeUrbanEnvironment.toLowerCase()).key;
        },

        getUrbanEnvironmentKeyIndexFromUrlParams: state => (activeSection, activeUrbanEnvironmentOrGeography) => {
            return state.dataJson[activeUrbanEnvironmentOrGeography]
                .findIndex(urbanEnvironment => urbanEnvironment.key.toLowerCase() === activeSection.toLowerCase());
        },

        // getUrbanEnvironmentsFilteredFromActiveUrbanSector: state =>  {
        //
        //     if(state.activeNavigation.activeUrbanSectors !== ''){
        //         console.log('state.activeNavigation.activeUrbanSectors', state.activeNavigation.activeUrbanSectors)
        //         console.log('state.dataJson.urbanEnvironments', state.dataJson.urbanEnvironments)
        //         return state.dataJson.urbanEnvironments.filter( urbanEnvironment =>{
        //             state.activeNavigation.activeUrbanSectors. urbanEnvironment
        //         })
        //     }else {
        //         return state.dataJson.urbanEnvironments
        //     }
        //         // .findIndex(urbanEnvironment => urbanEnvironment.key.toLowerCase() === activeUrbanEnvironment.toLowerCase());
        // },

        getGeographyKeyFromUrlParams: state => activeGeography => {
            return state.dataJson.geography
                .find(geography => geography.key.toLowerCase() === activeGeography.toLowerCase()).key;
        },
        getUrbanSectorsFromUrbanEnvironment: state => activeUrbanEnvironment => {
            return state.dataJson.urbanSectors
                .find(urbanSector => urbanSector.urbanEnvironments.map(x => x.toLowerCase())
                    .includes(activeUrbanEnvironment.toLowerCase()));
        },

        getUrbanSectorsFromGeogrphy: state => activeGeography => {
            return state.dataJson.urbanSectors
                .find(urbanSector => urbanSector.geography.toLowerCase() === activeGeography.toLowerCase());
        },

        getProjectsOfUrbanEnvironment: (state, getters) => urbanEnvironment => {
            return Object.values(getters.getProjects)
                .filter(project => project.urbanEnvironment.map(x => x.toLowerCase()).includes(urbanEnvironment.toLowerCase()))
        },
        getProjectsOfGeography: (state, getters) => geography => {
            return Object.values(getters.getProjects)
                .filter(project => project.geography.map(x => x.toLowerCase()).includes(geography.toLowerCase()))
        },
        getProjectById: (state, getters) => projectId => {
            return getters.getProjects.find(project => project.id.toLowerCase() === projectId.toLowerCase())
        },
        getUrbanSectorsFromProject: (state, getters) => (project, activeUrbanEnvironmentOrGeography) => {
            let TmpActiveUEOG = (activeUrbanEnvironmentOrGeography === 'urbanEnvironments') ? 'urbanEnvironment' : activeUrbanEnvironmentOrGeography;
            let urbanSectors = [];
            project[TmpActiveUEOG]?.forEach(proj => {
                urbanSectors.push(...state.dataJson.urbanSectors.filter(sector => {
                    return sector[activeUrbanEnvironmentOrGeography].includes(proj)
                }))
            })
            let uniq = a => [...new Set(a)];
            return uniq(urbanSectors.map(x => x.id));
        },
        getCorrelatedProjectsFromProject: (state, getters) => project => {
            let urbanEnvironments = [];
            project.urbanEnvironment.forEach(urbanEnvironment => {
                urbanEnvironments.push(...getters.getUrbanSectorsFromUrbanEnvironment(urbanEnvironment).urbanEnvironments);
            })
            urbanEnvironments = Array.from(new Set(urbanEnvironments).values())
            let projects = [];
            urbanEnvironments.forEach(urbanEnvironment => {
                projects.push(...getters.getProjectsOfUrbanEnvironment(urbanEnvironment));
            })
            projects = projects.filter(proj => proj.id !== project.id)
            return projects.slice(0, 4);
        },
        getSectionKey: (state, getters) => (urbanEnvironmentOrGeography, key) =>{
            return (urbanEnvironmentOrGeography.toLowerCase() === 'geography') ? getters.getGeographyKeyFromUrlParams(key) : getters.getUrbanEnvironmentKeyFromUrlParams(key);
        }
    }
})
export default store;
